import React from "react"
import PropTypes from "prop-types"

import { DialogContent, DialogTitle, DialogError, DialogActions, DialogProgress } from "ui-Dialog"
import Button from "@material-ui/core/Button"

import ScrollFrame, { ScrollFrameHeader, ScrollFrameBody, ScrollFrameFooter } from "ui-ScrollFrame"
import runMutation from "runMutation"

import Form, { FormCommitButton, FormErrors } from "ui-Form"

const styleSheet = theme => ({
  contentPadding: {
    paddingTop: theme.spacing.unit * 3,
  },
})

class DialogFormFrame extends React.Component {
  static propTypes = {
    actions: PropTypes.node,
    cancelLabel: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
    mutate: PropTypes.func.isRequired,
    mutation: PropTypes.object,
    root: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.object.isRequired]),
    submitLabel: PropTypes.node,
    title: PropTypes.node,

    onRunMutation: PropTypes.func,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    onSubmitted: PropTypes.func,
  }

  state = {}

  _handleSubmit = mutation => {
    const { mutate, onRunMutation, onSubmitted } = this.props

    if (onRunMutation) {
      onRunMutation(mutation, this)
    } else {
      const promise = runMutation(this, () => mutation.submit(mutate))

      if (onSubmitted) {
        promise.then(onSubmitted)
      }
    }
  }

  _handleCancel = () => {
    const { onCancel, mutation } = this.props

    mutation.reset()
    this.setState({ confirm: false }, onCancel)
  }

  _renderActions({ actions, submitLabel, onCancel, cancelLabel }) {
    if (actions) {
      return actions
    }

    actions = []

    if (onCancel) {
      actions.push(
        <Button onClick={this._handleCancel} key="cancel">
          {cancelLabel || "Cancel"}
        </Button>
      )
    }

    if (submitLabel) {
      actions.push(
        <FormCommitButton color="primary" key="submit">
          {submitLabel}
        </FormCommitButton>
      )
    }

    return actions
  }

  render() {
    const {
      actions,
      cancelLabel,
      children,
      classes,
      mutate,
      mutation,
      root,
      submitLabel,
      title,

      onCancel,
      onRunMutation,
      onSubmit,
      onSubmitted,

      ...otherProps
    } = this.props

    return (
      <Form
        onSubmit={onSubmit || this._handleSubmit}
        showErrors={false}
        inheritMutation
        flex
        {...otherProps}
      >
        <ScrollFrame>
          {title && (
            <ScrollFrameHeader>
              <DialogTitle>{title}</DialogTitle>
            </ScrollFrameHeader>
          )}
          <ScrollFrameBody>
            <DialogError
              in={!!this.state.mutationErrors}
              errors={this.state.mutationErrors}
              gutterBottom
            />
            <DialogContent className={!title && classes.contentPadding}>
              <FormErrors />
              {children}
            </DialogContent>
          </ScrollFrameBody>
          <ScrollFrameFooter>
            <DialogActions>
              {this._renderActions({
                actions,
                submitLabel,
                onCancel,
                cancelLabel,
              })}
            </DialogActions>
          </ScrollFrameFooter>
        </ScrollFrame>
        <DialogProgress in={this.state.submitting} cover />
      </Form>
    )
  }
}

import compose from "recompose/compose"
import withStyles from "@material-ui/core/styles/withStyles"
import { provideMutation } from "store/Mutation"

export default compose(withStyles(styleSheet), provideMutation())(DialogFormFrame)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Dialog/DialogFormFrame.js